export const baseUrl = {
    development:
        process.env.DOMAIN_URL ||
        'http://bumble-seasonal-content-hub-lb.bumble-web-services.common.k8s.mlan:8080',
    test:
        process.env.DOMAIN_URL ||
        'http://bumble-seasonal-content-hub-lb.bumble-web-services.common.k8s.mlan:8080',
    production: process.env.DOMAIN_URL || 'https://bumble.com',
}[process.env.NODE_ENV];
